import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "../client";

export const useAdminUser = (id: string) => {
  return useQuery({
    queryKey: ["admin", "users", id],
    queryFn: async () => {
      const res = await client.admin.user[":id"].$get({ param: { id } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!id,
  });
};
